






























































import { Vue, Component, Watch } from "vue-property-decorator";
import AuthService from "@/services/auth_service";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { GlobalActions, GlobalGetters } from "@/store/modules/global/types";
import { SalesRegions } from "@/models/map/region_type";
import { AuthError, GenericError } from "@/services/error_service";
import { Layers } from "@/models/map/layers";
import { UserActions, UserGetters } from "@/store/modules/user/types";
import { Roles } from "@/models/roles";
import Export from "@/views/Export.vue";
@Component({
  components: {
    Export
  }
})
export default class Header extends Vue {
  @(namespace(StoreModule.Global).Action(GlobalActions.AddActiveView))
  addActiveView;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetActiveView))
  storeActiveView;
  @(namespace(StoreModule.Global).Action(GlobalActions.AddLoggedIn))
  setLoggedIn;
  @(namespace(StoreModule.User).Getter(UserGetters.GetRole)) role;
  @(namespace(StoreModule.User).Action(UserActions.AddUser)) addUser;
  protected activeView: Layers = Layers.Customers;
  protected Roles = Roles;
  protected Layers = Layers;
  protected authService: AuthService = new AuthService();

  public async logout(): Promise<void> {
    try {
      this.setLoggedIn(false);
      this.addUser({});
      await this.authService.logout();
      this.$router.replace('/login').catch((err) => {});
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      } else {
        GenericError.popup(err.message);
      }
    }
  }

  @Watch('storeActiveView', {immediate: true})
    protected onViewChange(): void {
          this.activeView = this.storeActiveView;
    }

  public setActiveView() {
    this.addActiveView(this.activeView);
  }

  public triggerExportModal() {
    const options = {
      adaptive: true,
      width: "100%",
      height: "100%",
      scrollable: true,
      clickToClose: false,
      classes: 'export-modal'
    };
      this.$modal.show(
        Export,
        {},
        { ...options }
      );
    }
  }
  
